var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigaAppLigaquiz1StellaColore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0_quiz_1 {\n        fill: #e30f6f;\n      }\n\n      .st1_quiz_1 {\n        fill: #eee0bb;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1_quiz_1",
    d: "M69.4,141.1c-1.3-.5-33.1-13.2-48.6-53.1-1.4-3.2-2.6-6.6-3.5-10.1-1.8-6.6-2.7-13.7-2.7-21s1.4-16.3,4.1-25c2.6-8.5,6.9-17.3,12.7-26L35.4,0l5.2,5.1c1.3,1.3,2.8,2.3,4.4,3.1,1.9.9,3.9,1.5,5.9,1.8.4,0,.8,0,1.1.1.4,0,.8,0,1.2,0h.9c2.3-.1,4.6-.7,6.9-1.7,2.2-.9,4.1-2.2,5.7-3.7l4.1-3.7,4.1,3.7c1.6,1.5,3.6,2.7,5.7,3.7,2.3,1,4.6,1.5,7,1.7h.8c.4,0,.8,0,1.2,0,.5,0,.9,0,1.2-.1,1.9-.3,3.9-.9,5.8-1.8,1.7-.8,3.2-1.8,4.4-3.1L106.3,0l4.1,6.1c5.6,8.3,9.8,16.7,12.4,25h0s.3,1,.3,1c2.7,8.7,4.1,17.2,4.1,25s-.9,14.4-2.7,21c-.9,3.5-2.1,6.8-3.5,10.1-15.6,39.9-47.3,52.6-48.6,53.1l-1.5.6-1.5-.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0_quiz_1",
    d: "M103.5,64.2l-32.7,32.7-32.7-32.7c-8.1-8.1-8.1-21.2,0-29.3,4-4,9.4-6.1,14.7-6.1s10.6,2,14.7,6.1c1.4,1.4,2.5,2.8,3.4,4.4.9-1.6,2-3.1,3.4-4.4,4-4,9.4-6.1,14.7-6.1s10.6,2,14.7,6.1c8.1,8.1,8.1,21.2,0,29.3ZM68.5,110.8h-7.5l6,4.4-2.3,7.1,6-4.4,6,4.4-2.3-7.1,6-4.4h-7.5l-2.3-7.1-2.3,7.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigaAppLigaquiz1StellaColore);
export default __webpack_public_path__ + "static/media/LIGA_APP_ligaquiz_1_stella_colore.c5b39e3da33a76bbaadebc87bc6ea251.svg";
export { ForwardRef as ReactComponent };